export default "__VITE_ASSET__BqHkKUmX__"